<template>
  <footer class="footer">
    </footer>
</template>
<script>
    export default {};
</script>
<style scoped>
    .footer .container-fluid nav ul li,
    .footer .container-fluid .copyright {
            padding: 0;
            margin: 0;
    }
</style>
